import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationsComponent } from '../notifications.component';
import { constants, NotificationAlertIndicatorService } from '@edassist/common';
import { SliderService } from '@edassist-ui/services';
import {
	AuthenticationService,
	ContentService,
	NotificationService,
	ParticipantService
} from '@edassist/api';
import { LoadingContainerService } from '@edassist/shared';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
@Component({
	selector: 'ea-notifications-slider',
	templateUrl: './notifications-slider.component.html',
	styleUrls: ['../notifications.component.scss']
})
export class NotificationsSliderComponent
	extends NotificationsComponent
	implements OnInit, OnDestroy
{
	isNotificationSliderOpenRead = false;
	private readonly subscriptions = new Subscription();

	constructor(
		private readonly sliderService: SliderService,
		readonly notificationsService: NotificationService,
		readonly authService: AuthenticationService,
		readonly participantService: ParticipantService,
		readonly contentService: ContentService,
		readonly notificationAlertIndicatorService: NotificationAlertIndicatorService,
		readonly loadingService: LoadingContainerService,
		readonly route: ActivatedRoute
	) {
		super(
			authService,
			notificationsService,
			participantService,
			contentService,
			notificationAlertIndicatorService,
			loadingService
		);
	}

	ngOnInit(): void {
		this.isNotificationPageAvailable = false;
		this.subscriptions.add(
			this.sliderService.openSliderEvent.subscribe((sliderId) => {
				if (sliderId === constants.sliderIds.NOTIFICATION) {
					this.continuationToken = '';
					this.pageNumber = 0;
					this.isNotificationPageAvailable = true;
				}
			})
		);
	}

	handleKeyDown(): void {
		this.isNotificationSliderOpenRead = true;
	}

	ngOnDestroy(): void {
		this.subscriptions?.unsubscribe();
	}

	closeSlider(): void {
		this.sliderService.closeSlider(constants.sliderIds.NOTIFICATION);
		this.isNotificationSliderOpenRead = false;
		this.isNotificationPageAvailable = false;
	}
}
